<div class="">
    <div class="page-content">
        <h2 class="heading1">Sales Order</h2>
        <div class="mt-4">
            <mat-card>
                <mat-card-content>
                    <h3 class="heading2">Customer Detail</h3>
                    <div class="entry-forms w-55">
                        <div class="row">
                            <div class="col-md-6">
                                <label class="f-label"> Customer Code </label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput readonly>
                                   <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <label class="f-label">Customer Name</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="mt-2">
                            <div class="row">
                                <div class="col-md-6">
                                    <h3 class="heading6 mb-2">Billing Address
                                        <i-feather class="t-icon ms-2 pointer" name="edit-2" [matMenuTriggerFor]="menu"></i-feather>
                                        
        <mat-menu #menu="matMenu" class="so-edit-address" yPosition="below">
            <mat-list class="">
              <mat-list-item class="selected">
                <span class="">Wz-2, Ring Road, Mansarover Garden Delhi, Delhi, 110015</span>
              </mat-list-item>
              <mat-list-item class="">
                <span class="">Wz-2, Ring Road, Mansarover Garden Delhi, Delhi, 110015</span>
              </mat-list-item>
              <mat-list-item class="">
                <span class="">Wz-2, Ring Road, Mansarover Garden Delhi, Delhi, 110015</span>
              </mat-list-item>
            </mat-list>
          </mat-menu>
                                    </h3>
                                    <p class="fs-7">
                                        <span>
                                            Wz-2, Ring Road, Mansarover Garden Delhi, Delhi, 110015
                                        </span>
                                    </p>
                                </div>
                                <div class="col-md-6">
                                    <h3 class="heading6 mb-2">Shipping Address
                                        <i-feather class="t-icon pointer ms-2" name="edit-2" [matMenuTriggerFor]="menu1"></i-feather>
                                        
                                        <mat-menu #menu1="matMenu" class="so-edit-address" yPosition="below">
                                            <mat-list class="">
                                              <mat-list-item class="selected">
                                                <span class="">Wz-2, Ring Road, Mansarover Garden Delhi, Delhi, 110015</span>
                                              </mat-list-item>
                                              <mat-list-item class="">
                                                <span class="">Wz-2, Ring Road, Mansarover Garden Delhi, Delhi, 110015</span>
                                              </mat-list-item>
                                              <mat-list-item class="">
                                                <span class="">Wz-2, Ring Road, Mansarover Garden Delhi, Delhi, 110015</span>
                                              </mat-list-item>
                                            </mat-list>
                                          </mat-menu>
                                    </h3>
                                    <p class="fs-7">
                                        <span>
                                            36, Crown Motor Market, Tilak Gali, Kashmere Gate Delhi, Delhi, 110006
                                        </span>
                                    </p>
                                </div>
                                <div class="col-md-6">
                                    <h3 class="heading6 mb-2">Currency</h3>
                                    <p class="fs-7">
                                        <span class="rupee-icon1 me-1">&#8377;</span>
                                        <span>INR- Indian Rupee</span>
                                    </p>
                                </div>
                            </div>
                            <!-- if no customer is selected -->
                            <!-- <div class="row">
                                <div class="col-md-6 text-center">
                                    <img src=".././assets/images/sales-orders.png" alt="" class="nodata-img">
                                    <p class="no-data mt-2">No customer is selected</p>
                                </div>
                            </div> -->
                        </div>

                        <div class="row mt-4">
                            <div class="col-md-6">
                                <label class="f-label">
                                    <span class="required">*</span>Place of Supply </label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput readonly>
                                   <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <label class="f-label">
                                    <span class="required">*</span>Contact Person</label>
                                <mat-form-field class="full-width" appearance="outline">
                                    <input type="text" matInput readonly>
                                   <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                </mat-form-field>
                            </div>
                        </div>

                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card class="mt-4">
                <mat-card-content>
                    <h3 class="heading2">Sales Detail</h3>
                    <div class="entry-forms">
                        <div class="row">
                            <div class="col-md-6 pe-5">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="f-label"> <span class="required">*</span>Branch Name </label>
                                        <mat-form-field class="full-width" appearance="outline">
                                            <mat-select>
                                                <mat-option value=""></mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-md-6">
                                        <label class="f-label"><span class="required">*</span>Sales Employee</label>
                                        <mat-form-field class="full-width" appearance="outline">
                                            <input type="text" matInput readonly>
                                           <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="f-label"><span class="required">*</span>Payment Terms </label>
                                        <mat-form-field class="full-width" appearance="outline">
                                            <mat-select>
                                                <mat-option value=""></mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-12">
                                        <label class="f-label">Reference number</label>
                                        <mat-form-field class="full-width" appearance="outline">
                                            <input type="text" matInput>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 pe-5">
                                <div class="row">
                                    <div class="col-md-4">
                                        <label class="f-label"><span class="required">*</span>Status </label>
                                        <mat-form-field class="full-width" appearance="outline">
                                            <mat-select>
                                                <mat-option value=""></mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="f-label"><span class="required">*</span>Document Series </label>
                                        <mat-form-field class="full-width" appearance="outline">
                                            <mat-select>
                                                <mat-option value=""></mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="f-label"><span class="required">*</span>Document Number</label>
                                        <mat-form-field class="full-width" appearance="outline">
                                            <input type="text" matInput>
                                        </mat-form-field>
                                    </div>
                                    <!-- <div class="col-md-4">
                                        <label class="f-label"><span class="required">*</span> Document Date </label>
                                        <mat-form-field appearance="outline">
                                            <input matInput [matDatepicker]="picker" (click)="picker.open()"
                                                placeholder="dd/mm/yyyy" readonly>
                                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                    </div> -->
                                    <!-- <div class="col-md-4">
                                        <label class="f-label"><span class="required">*</span>Posting Date </label>
                                        <mat-form-field appearance="outline">
                                            <input matInput [matDatepicker]="picker" (click)="picker.open()"
                                                placeholder="dd/mm/yyyy" readonly>
                                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                    </div> -->
                                    <!-- <div class="col-md-4">
                                        <label class="f-label"><span class="required">*</span>Expected Delivery Date
                                        </label>
                                        <mat-form-field appearance="outline">
                                            <input matInput [matDatepicker]="picker" (click)="picker.open()"
                                                placeholder="dd/mm/yyyy" readonly>
                                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                    </div> -->
                                    <div class="col-md-12">
                                        <label class="f-label"><span class="required">*</span>Shipment Preference
                                        </label>
                                        <mat-form-field class="full-width" appearance="outline">
                                            <mat-select>
                                                <mat-option value=""></mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </mat-card-content>
            </mat-card>
            
            <mat-card class="mt-4">
                <mat-card-content>
                    <h3 class="heading2">Item Detail</h3>
                    <div class="entry-forms">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="tabledesign itemdetailtable">
                                    <table mat-table [dataSource]="dataSource">
    
                                        <!-- ============ Item Detail ============ -->
                                        <ng-container matColumnDef="item_detail">
                                            <th mat-header-cell *matHeaderCellDef> Item Detail </th>
                                            <td mat-cell *matCellDef="let row">
                                                <div class="px-2">
                                                    <div class="mb-2">
                                                        <mat-form-field class="field-bottom-0 w-180 mb-0" appearance="outline">
                                                            <input type="text" matInput placeholder="Search Item" readonly>
                                                           <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="mb-2">
                                                        <mat-form-field class="field-bottom-0 w-180 mb-0" appearance="outline">
                                                            <input type="text" matInput>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="">
                                                        <span class="fs-9">HSN/SAC</span>
                                                        <span class="ps-2">
                                                            <mat-form-field class="w-120 field-bottom-0" appearance="outline">
                                                                <input type="text" matInput>
                                                            </mat-form-field>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>
    
                                        <!-- ============ Unit/Qty Open Qty  Column ============ -->
                                        <ng-container matColumnDef="unit_qty">
                                            <th mat-header-cell *matHeaderCellDef> Unit/Qty. </th>
                                            <td mat-cell *matCellDef="let row">
                                                <div class="mb-2 d-flex px-2">
                                                    <div class="fs-9 mb-1 w-62">UOM</div>
                                                    <mat-form-field class="w-120 field-bottom-0 mb-0" appearance="outline">
                                                        <mat-select>
                                                            <mat-option value=""></mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                                <div class="mb-2 d-flex px-2">
                                                    <div class="fs-9 mb-1 w-62">Qty</div>
                                                    <mat-form-field class="w-120 field-bottom-0 mb-0" appearance="outline">
                                                        <input type="text" matInput>
                                                    </mat-form-field>
                                                </div>
                                                <div class="d-flex px-2">
                                                    <div class="fs-9 mb-1 w-62">Open Qty.</div>
                                                    <mat-form-field class="w-120 field-bottom-0 mb-0" appearance="outline">
                                                        <input type="text" matInput>
                                                    </mat-form-field>
                                                </div>
                                            </td>
                                        </ng-container>
    
                                        <!-- ============ Warehouse Detail Column ============ -->
                                        <ng-container matColumnDef="warehouse_detail">
                                            <th mat-header-cell *matHeaderCellDef>Warehouse Detail</th>
                                            <td mat-cell *matCellDef="let row" class="px-2">
                                                <div class="px-2">
                                                    <div class="mb-2">
                                                        <mat-form-field class="field-bottom-0 w-140 mb-0" appearance="outline">
                                                            <input type="text" matInput readonly>
                                                           <img src="./assets/images/cfl.svg" matSuffix alt="" class="me-2">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="">
                                                        <div class="fs-9 pb-1">Warehouse Location</div>
                                                        <div class="">Greater Noida</div>
                                                    </div>
                                                    <div class="">
                                                        <div class="fs-9 py-1">Warehouse Quantity</div>
                                                        <div class="">&#8377; 15000</div>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>
    
                                        <!-- ============ Delivery Date Column ============ -->
                                        <ng-container matColumnDef="delivery_date">
                                            <th mat-header-cell *matHeaderCellDef> Delivery Date </th>
                                            <td mat-cell *matCellDef="let row">
                                                <!-- <div class="text-center full-width px-2">
                                                    <mat-form-field appearance="outline" class="w-150 field-bottom-0">
                                                        <input matInput [matDatepicker]="picker1" (click)="picker1.open()"
                                                            placeholder="dd/mm/yyyy" readonly>
                                                        <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                                                        <mat-datepicker #picker1></mat-datepicker>
                                                    </mat-form-field>
                                                </div> -->
                                            </td>
                                        </ng-container>
    
                                        <!-- ============ Unit Price Column ============ -->
                                        <ng-container matColumnDef="discount">
                                            <th mat-header-cell *matHeaderCellDef> Discount </th>
                                            <td mat-cell *matCellDef="let row">
                                                <div class="mb-2 px-2">
                                                    <mat-form-field class="w-150 field-bottom-0 mb-0" appearance="outline">
                                                        <input type="text" matInput>
                                                    </mat-form-field>
                                                </div>
                                                <div class="px-2">
                                                    <div class="fs-9 mb-1">Unit Price</div>
                                                    <div class="">&#8377; 20000</div>
                                                </div>
                                                <div class="px-2">
                                                    <div class="fs-9 mb-1">Price after discount</div>
                                                    <div class="">&#8377; 22500</div>
                                                </div>
                                            </td>
                                        </ng-container>
    
                                        <!-- ============ Tax Column ============ -->
                                        <ng-container matColumnDef="tax">
                                            <th mat-header-cell *matHeaderCellDef>Tax</th>
                                            <td mat-cell *matCellDef="let row;">
                                                <div class="mb-2 px-2">
                                                    <mat-form-field class="w-120 field-bottom-0 mb-0" appearance="outline">
                                                        <input type="text" matInput readonly>
                                                        <mat-icon matSuffix >layers</mat-icon>
                                                    </mat-form-field>
                                                </div>
                                                <div class="pt-2 px-2">
                                                    <div class="fs-9 mb-1">Tax Amount</div>
                                                    <div class="">&#8377; 2000</div>
                                                </div>
                                            </td>
                                        </ng-container>
    
                                        <!-- ============ Amount Column ============ -->
                                        <ng-container matColumnDef="amount">
                                            <th mat-header-cell *matHeaderCellDef> Amount </th>
                                            <td mat-cell *matCellDef="let row; let i = index">
                                                <div class="mb-2 px-2">
                                                    <mat-form-field class="w-120 field-bottom-0 mb-0" appearance="outline">
                                                        <input type="text" matInput readonly>
                                                        <mat-icon matSuffix >layers</mat-icon>
                                                    </mat-form-field>
                                                </div>
                                                <div class="p-1 px-2 text-end">
                                                    <i-feather class="t-icon me-2 pointer" name="copy"> </i-feather>
                                                    <i-feather class="t-icon popinter pointer" name="trash-2"
                                                        > </i-feather>
                                                </div>
                                            </td>
                                        </ng-container>
    
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row class="tablecard"
                                            *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        
                    <div class="row mt-2">
                        <div class="col-md-5">
                            <button mat-stroked-button color="primary">Add New Item</button>
                        </div>
                        <div class="col-md-7">
                            <div class="entry-forms accounting-section">
                                        <div class="acclist">
                                            <div class="p-0 pb-2 acclist-item">
                                                <div class="me-auto">Total before discount</div>
                                                <div>&#8377; 22,500.00</div>
                                            </div>
                                            <div class="divider"></div>
                                            <div class="p-0 acclist-item">
                                                <div class="align-self-center">Discount</div>
                                                <div class="ms-auto me-auto pt-2 pb-1">
                                                    <mat-form-field class="w-80 field-bottom-0" appearance="outline">
                                                        <input type="text" matInput placeholder="eg. 10%">
                                                    </mat-form-field>
                                                </div>
                                                <div class="align-self-center">&#8377; 2,000.00</div>
                                            </div>
                                            <div class="divider"></div>
                                            <div class="p-0 pt-3 pb-3 acclist-item">
                                                <div class="align-self-center">Freight</div>
                                                <div class="ms-auto me-auto link"
                                                (click)="openDialog()">View Freight</div>
                                                <div class="align-self-center">&#8377; 18,000.00</div>
                                            </div>
                                            <div class="divider"></div>
                                            <div class="p-0 my-3 acclist-item">
                                                <div class="me-auto align-self-center">Tax</div>
                                                <div>&#8377; 18,000.00</div>
                                            </div>
                                            <div class="divider"></div>
                                            <div class="p-0 acclist-item">
                                                <div class="align-self-center">Adjustment
                                                    <mat-checkbox></mat-checkbox>
                                                </div>
                                                <div class="pt-2 ms-auto me-auto pb-1">
                                                    <mat-form-field class="w-120 field-bottom-0" appearance="outline">
                                                        <input type="text" matInput>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="divider"></div>
                                        </div>
                                        <div class="py-4 d-flex">
                                            <div class="me-auto fs-6 fw-bold pt-2">Total</div>
                                            <div class="fs-6 fw-bold">&#8377;57,00,000.00 </div>
                                        </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </mat-card-content>
            </mat-card>
            
            <mat-card class="mt-4">
                <mat-card-content>
                    <h3 class="heading2">Additional Detail</h3>
                    <div class="entry-forms additional-details">
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <label class="f-label">Export</label>
                                <mat-slide-toggle class="ms-3" color="primary"></mat-slide-toggle>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <label class="f-label">Remarks</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <input type="text" matInput>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5 mb-3">
                                    <label class="f-label">Customer Notes</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <textarea matInput rows="4"
                                            placeholder="Write notes to be displayed in your transaction"></textarea>
                                        <mat-hint>Maximum characters limit: 250</mat-hint>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="divider"></div>
                            <div class="row">
                                <div class="col-md-12 mt-3">
                                    <label class="f-label full-width">Attachment</label>
                                    <button mat-raised-button class="uploadbtn" color="primary">
                                        <i-feather class="t-icon" name="upload"> </i-feather>
                                        Upload Files
                                    </button>
                                    <span class="field-hint d-block">You can upload a maximum of 10 files, 5MB each</span>
                                </div>
                                <div class="col-md-12 mt-4">
                                    <div class="carddesign">
                                        <div class="row px-3">
                                            <label class="col-md-2 f-label">Thumbnail</label>
                                            <label class="col-md-6 f-label">File Name</label>
                                            <label class="col-md-2 f-label">File Size</label>
                                            <label class="col-md-2 f-label"></label>
                                        </div>
                                        <mat-card class="add-detail-files mb-2">
                                            <mat-card-content class="py-2">
                                                <div class="row">
                                                    <div class="col-md-2">
                                                        <i-feather class="" name="image"></i-feather>
                                                    </div>
                                                    <div class="col-md-6">item-receipt.jpg</div>
                                                    <div class="col-md-2">10 KB</div>
                                                    <div class="col-md-2">
                                                        <i-feather class="t-icon pointer" name="trash-2"></i-feather>
                                                    </div>
                                                </div>
                                            </mat-card-content>
                                        </mat-card>
                                        <mat-card class="add-detail-files mb-2">
                                            <mat-card-content class="py-2">
                                                <div class="row">
                                                    <div class="col-md-2">
                                                        <i-feather class="" name="image"></i-feather>
                                                    </div>
                                                    <div class="col-md-6">item-receipt.jpg</div>
                                                    <div class="col-md-2">10 KB</div>
                                                    <div class="col-md-2">
                                                        <i-feather class="t-icon pointer" name="trash-2"></i-feather>
                                                    </div>
                                                </div>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                </div>
                                <div class="col-md-5 mt-4 mb-3">
                                    <label class="f-label">Terms and Conditions</label>
                                    <mat-form-field class="full-width" appearance="outline">
                                        <textarea matInput rows="4"
                                            placeholder="Write terms and conditions of your business"></textarea>
                                        <mat-hint>Maximum characters limit: 250</mat-hint>
                                    </mat-form-field>
                                </div>
                                <div class="divider"></div>
                                <div class="col-md-12 mt-3">
                                    <div class="row">
                                        <label class="f-label col-md-6">Email To</label>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 tabledesign">
                                            <mat-chip-listbox class="example-chip">
                                                <mat-chip class="example-box">
                                                    Anil Kumar <span>anil.kumar&#64;gmail.com</span>
                                                    <button matChipRemove>
                                                        <mat-icon>cancel</mat-icon>
                                                    </button>
                                                </mat-chip>
                                                <mat-chip class="example-box">
                                                    Ved Prakash <span>ved.prakash&#64;gmail.com</span>
                                                    <button matChipRemove>
                                                        <mat-icon>cancel</mat-icon>
                                                    </button>
                                                </mat-chip>
                                                <mat-chip class="example-box">
                                                    Ved Prakash <span>ved.prakash&#64;gmail.com</span>
                                                    <button matChipRemove>
                                                        <mat-icon>cancel</mat-icon>
                                                    </button>
                                                </mat-chip>
                                            </mat-chip-listbox>
                                        </div>
                                        <div class="col-md-12 mt-4 mb-2">
                                            <button mat-stroked-button color="primary">
                                                <i-feather class="t-icon pointer" name="mail"></i-feather>
                                                Add Email</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

            <div class="text-end">
                                  
            <button class="me-2 copyfrom pe-2" mat-raised-button color="primary" [matMenuTriggerFor]="menucopy">
                Copy From
                <mat-icon class="ms-1">keyboard_arrow_up</mat-icon>
            </button>
            
            <mat-menu #menucopy="matMenu" class="" yPosition="below">
                <button mat-menu-item (click)="openDialog1()">Sales Quotations</button>
                <button mat-menu-item>Sales Orders</button>
                <button mat-menu-item>Returns</button>
                <button mat-menu-item>Blanket Agreement</button>
            </mat-menu>

        <button class="copyto pe-2" mat-raised-button color="primary">Copy To 
            <mat-icon class="ms-1">keyboard_arrow_up</mat-icon></button>

            </div>
        </div>
    </div>
    <div class="mt-2 footer">
        <div class="row">
        <div class="col-md-6">
            <button #buttonSave mat-raised-button color="primary" class="me-1">Save</button>
            <button mat-raised-button color="primary" class="me-1">Preview before submit</button>
            <button class="me-2" #buttonCancel mat-raised-button>Cancel</button>
        </div>
        <div class="col-md-6 text-end">
            <div class="pt-2">
                <span class="fs-8 pt-2 pe-3">Total: </span>
                <span class="fs-6 fw-bold">&#8377;57,00,000.00 </span>
            </div>
        </div>
        </div>
    </div>
</div>